import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=template&id=61712afb&scoped=true&"
import script from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61712afb",
  null
  
)

export default component.exports